
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
  name: "mb-range",
  props: {
    label: { type: String, default: "", required: true },
    shortKey: { type: String, default: "" },
    modelValue: { type: String, default: "-" },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const rangeValMin = ref("");
    const rangeValMax = ref("");

    watch(
      () => props.modelValue,
      (newVal) => {
        console.log(newVal);
        rangeValMin.value = newVal.split("-")[0];
        rangeValMax.value = newVal.split("-")[1];
      }
    );

    const handleMinInput = (value) => {
      rangeValMin.value = value;
      context.emit(
        "update:modelValue",
        rangeValMin.value + "-" + rangeValMax.value
      );
    };

    const handleMaxInput = (value) => {
      rangeValMax.value = value;
      context.emit(
        "update:modelValue",
        rangeValMin.value + "-" + rangeValMax.value
      );
    };

    return {
      rangeValMin,
      rangeValMax,
      handleMinInput,
      handleMaxInput,
    };
  },
});
